// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d417b13f","884":"8d84add9","954":"04acbe07"}[chunkId] + ".chunk.js";
};